import React from 'react';
import Dialog from '@mui/material/Dialog';
import { DialogContent, DialogTitle, Slide } from '@mui/material';
import cross from '../../../../assets/svg/cross.svg';

import styles from './ShareSocialDialog.module.scss';
import { useUser } from '../../../../providers/user.provider';
import { TransitionProps } from '@mui/material/transitions';
import './ShareSocialDialog.scss';
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton, LinkedinIcon,
  LinkedinShareButton, PinterestIcon, PinterestShareButton,
  TwitterIcon,
  TwitterShareButton
} from 'react-share';

interface ITolDialog {
  open: boolean;
  onClose: () => void;
  [key: string]: any;
  url?: string;
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ShareSocialDialog = (props: ITolDialog) => {
  const user = useUser();
  const { onClose } = props;

  const handleClose = () => {
    onClose && onClose();
  };

  // Helper: build URL — uses custom domain if active, otherwise standard back URL
  const buildUrl = (path?: string): string => {
    if (!path) return process.env.REACT_APP_BACK_URL || '';
    const backUrl = process.env.REACT_APP_BACK_URL || '';
    const fallback = backUrl.replace(/\/$/, '') + '/' + path;
    if (!user?.user?.customDomain?.isActive || !user?.user?.customDomain?.domain) {
      return fallback;
    }
    let domain = user.user.customDomain.domain;
    if (!domain.startsWith('http')) domain = 'https://' + domain;
    try {
      const urlObj = new URL(domain);
      urlObj.pathname = path;
      return urlObj.toString();
    } catch {
      return fallback;
    }
  };
  // Use URL passed as prop — no transformation, exact URL from parent
  const activeUrl = props.url || buildUrl(user.currentOLink?.path);
  return (
    <Dialog
      sx={{
        zIndex: 1400,
      }}
      onClose={handleClose}
      open={props.open}
      keepMounted
      TransitionComponent={Transition}
      className={styles.share + ' share-social'}
    >
      <DialogTitle className={styles.share__title}>
        <button className={styles.share__close} onClick={handleClose}>
          <img src={cross} alt='Close edit' width={24} height={24}/>
        </button>
      </DialogTitle>
      <DialogContent className={styles.share__content}>
        <div className={styles.share__row}>
          <FacebookShareButton url={activeUrl} quote={'OLink'}>
            <FacebookIcon size={62}/>
          </FacebookShareButton>
          <TwitterShareButton url={activeUrl} title={'OLink'}>
            <TwitterIcon size={62}/>
          </TwitterShareButton>
          <LinkedinShareButton url={activeUrl}>
            <LinkedinIcon size={62}/>
          </LinkedinShareButton>
          <PinterestShareButton url={activeUrl} media={`test`}>
            <PinterestIcon size={62} />
          </PinterestShareButton>
          <EmailShareButton url={activeUrl} subject={'OLink'} body="body">
            <EmailIcon size={62} />
          </EmailShareButton>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ShareSocialDialog;
